import './../../../scss/app.scss';


const loc = window.location.href;
const reg      = new RegExp(/^(acct_)\d+/i);

const CRM_ACCOUNT_IDs = document.body.className.split(' ')
                .filter( name => reg.test(name));

if (loc.indexOf("purchaserulemgmt") > -1) {
    import("./../../account/purchase_management/index.js").then(module => {
        $(function() {
            let page = new module.default('#purchase_rule_management_container');
            page.init();
        })
    })
}

if (loc.indexOf("/account/password.html") > -1) {
    import("./../../account/password/index.js").then(module => {
        $(function() {
            let page = new module.default('.manage-account');
            page.init();
        })
    })
}

if (loc.indexOf("/site/account/") > -1) {
    import("./../../account/address_body/index.js").then(module => {
        $(function() {
            let page = new module.default('.account-address');
            page.init();

            window.setOldBillingAddress = page.setOldBillingAddress.bind(page);
        })
    })
}

if (loc.indexOf("standard_page") > -1) {     
    
    import("./../../standard/std_page/index.js").then(module => {
            let page = new module.default('.standards-page');
            page.init();
    });
}
/*
ZONES CONNECT - LEFT SIDEBAR

$(function() {
    if (loc.indexOf("standard_page") > -1) {     
        
        import("./../../standard/std_page/acct_542493/index.js").then(module => {
                let page = new module.default('.standards-page');
                page.init();
        })
        
        import("./../../standard/std_page/index.js").then(module => {
                let page = new module.default('.standards-page');
                page.init();
        });
    }

    if (document.getElementById("zc-sidebar") !== null) {
        import("./../../account/account_right/acct_542493/index.js").then(module => {
                let ZC_Sidebar = new module.default("aside#zc-sidebar");
                ZC_Sidebar.init();
                ZC_Sidebar.show_page();
            });
    }
})
*/
// ACCOUNT CUSTOMIZATION
const CRM_ACCOUNT_ID = CRM_ACCOUNT_IDs[0];
/*
CRM Account # 3404463
Oracle Acct ID:  300207853
*/
if (
    loc.indexOf("/site/expressemailquote/index.html") > -1 && 
    CRM_ACCOUNT_ID.indexOf("3404463") > -1
) {
    import('./account_3404463/express_email_quote/index.js');
}

/*
Account ID: 2754944
Web ID: 300176702
*/
if (
    (loc.indexOf("/site/standard_page/index.html") > -1 || 
    loc.indexOf("/site/locate/search.html") > -1 || 
    loc.indexOf("/site/cart/index.html") > -1 || 
    loc.indexOf("/site/product/index.html") > -1) && 
    CRM_ACCOUNT_ID === "acct_2754944" 
) {
    import('./account_2754944/index.js')
}

/*
Account # 3910737
Account ID: 300177103
*/
if (
    loc.indexOf("/site/standard_page/index.html") > -1 && 
    CRM_ACCOUNT_ID === "acct_3910737"
) {
    import('./account_3910737/standard_page/index.js');
}

/*
Account # 866897
Web ID: 300261475
*/
if (CRM_ACCOUNT_ID === "acct_866897") {
    import('./account_866897/index.js');
}

export default class ZonesPage {

    constructor() {
        this.account_id = -1;
    }

    bootstrap() {
        let self = this;

        self.import_files(self.account_id)
    }

    setAccountId(account_id) {
        return this.account_id = account_id;
    }

    getAccountId() {
        return this.account_id;
    }

    import_files(account_id) {
        
        // APPLY TO ALL PAGES
        loadProductPage();

        switch(account_id) {
            case 542493: 
            case 1566687: {
                loadZonesConnectDesign();
                break;
            }
            default: {
                break;
            }
        }
    }
}

const loadZonesConnectDesign = () => {
    let logo_el = document.getElementById('js-z-logo');
    let href    = logo_el ? logo_el.getAttribute('href') : '';
    let is_zone_business = !!(href.indexOf('zone=business') > -1 )

    if (!is_zone_business) return false;

    if (window.location.href.indexOf("standard_page") > -1) {
        import("./../../standard/std_page/acct_542493/index.js").then(module => {
            let page = new module.default('.standards-page');
            page.init();
        })
    }

    if (document.querySelector("#zc-sidebar") !== null) {
        import('./../../account/account_right/acct_542493/index.js').then(module => {
            let page = new module.default("#zc-sidebar");
            page.init();
            page.show_page();
        })
        
    }
}

const loadProductPage = () => {
    if (window.location.href.indexOf("/product/index.html") > -1) {
        import("./../../product/product_page_business/index.js").then(module => {
            let page = new module.default('#body', 82,5);
            page.renderProductImage();
        })
    }
}

$(function() {
    const zpage = new ZonesPage();

    if (CRM_ACCOUNT_ID != '' && CRM_ACCOUNT_ID != undefined) {
        const account_id = Number(CRM_ACCOUNT_ID.replace('acct_',''))
        zpage.setAccountId(account_id);
    }
    zpage.bootstrap();
})